import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { usePreferenceV2 } from 'app-components/flux/preferences-v2';

export const useMaskAmount = () => {
  const privacyMode = useSelector((state: any) => featureFlagsSelectors.getFeatureFlag(state, 'privacyMode'));
  const [sPrivacyMode] = usePreferenceV2('sPrivacyMode');
  const isPrivacyMode = privacyMode && sPrivacyMode;

  const maskAmount = useCallback(
    (text: string) => {
      if (isPrivacyMode) {
        return text.replace(/\$\s*[+-]?((\d{1,3}(,\d{3})+|\d+)(\.\d+)?|\.\d+)/g, '$***');
      }
      return text;
    },
    [isPrivacyMode],
  );
  return maskAmount;
};

export default useMaskAmount;
